import React, {useEffect, useState} from 'react';
import {QueryParamConfig} from 'serialize-query-params/lib/types';
import {StringParam, useQueryParams} from 'use-query-params';
import {ReportsOverview} from './ReportsOverview';
import {DashboardFilters} from './DashboardFilters';
import {TodayChart} from './TodayChart';
import {Currencies} from 'api/generated';

export type FilterType =
  | 'acquirer'
  | 'masterAccountId'
  | 'billingPlan'
  | 'paymentMethod'
  | 'source';

export type FilterByValue = {
  filterBy?: FilterType;
  filterValue?: string;
};

export const Dashboard: React.FC = () => {
  const [currency, setCurrency] = useState<Currencies>(Currencies.EUR);
  const [{acquirer, masterAccountId, billingPlan, paymentMethod, source}] = useQueryParams({
    acquirer: StringParam as QueryParamConfig<string | undefined>,
    masterAccountId: StringParam as QueryParamConfig<string | undefined>,
    billingPlan: StringParam as QueryParamConfig<string | undefined>,
    paymentMethod: StringParam as QueryParamConfig<string | undefined>,
    source: StringParam as QueryParamConfig<string | undefined>
  });

  const getFilterBy = () => {
    if (acquirer) return 'acquirer' as FilterType;
    if (masterAccountId) return 'masterAccountId' as FilterType;
    if (billingPlan) return 'billingPlan' as FilterType;
    if (paymentMethod) return 'paymentMethod' as FilterType;
    if (source) return 'source' as FilterType;
    return undefined;
  };
  const [filterBy, setFilterBy] = useState(getFilterBy);

  const getFilterValue = () => {
    return acquirer || masterAccountId || billingPlan || paymentMethod || source || '';
  };
  const [filterValue, setFilterValue] = useState(getFilterValue);

  useEffect(() => {
    setFilterBy(getFilterBy());
    setFilterValue(getFilterValue);
  }, [acquirer, masterAccountId, billingPlan, paymentMethod, source]);

  return (
    <>
      <DashboardFilters filterBy={filterBy} filterValue={filterValue} />
      <TodayChart
        filterBy={filterBy}
        filterValue={filterValue}
        selectedCurrency={currency}
        setCurrency={setCurrency}
      />
      <ReportsOverview filterBy={filterBy} filterValue={filterValue} selectedCurrency={currency} />
    </>
  );
};
